import { useHistory } from "react-router-dom";
import * as Styles from "./Kalorien.styles";
import DataSlider, {
  BoxTitle,
  ContentContainer,
  Details,
} from "components/common/DataSlider";

import LineChart from "components/lineChart/LineChart";
import KalorienSlider from "./KalorienSlider";
import MainHeader from "../../../components/Wrapper/HealthAnalyseHeader";
import { TEILNEHMER } from "routes/routes";
import { NutritionPieChart } from "pages/onboarding/macro-nutrients/MacroNutrients";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";

function Kalorien() {
  const history = useHistory();
  const { allNutritionsData } = useSelector((state) => state.coach);

  const [showDesktopView, setShowDesktopView] = useState(false);
  const handleBtnClick = (type) => {
    if (type === "mobile") {
      history.push(TEILNEHMER);
      return;
    }
    if (showDesktopView) {
      history.push(TEILNEHMER);
    } else setShowDesktopView(true);
  };

  // Transform weekWiseData into a flat array for LineChart
  const LineChartData = useMemo(() => {
    // Check if weekWiseData exists
    if (!allNutritionsData?.weekWiseData) return [];

    // Create an array to hold all days from all weeks
    const allDays = [];

    // Iterate through each week property (week1, week2, etc.)
    Object.keys(allNutritionsData.weekWiseData).forEach(
      (weekKey, weekIndex) => {
        const weekData = allNutritionsData.weekWiseData[weekKey];

        // Skip if weekData is not an array
        if (!Array.isArray(weekData)) return;

        // Add each day from this week to the allDays array, with week information
        weekData.forEach((day, dayIndex) => {
          allDays.push({
            name: `${day.daytypeID} (W${weekIndex + 1}D${dayIndex + 1})`,
            dayType: day.daytypeID,
            value: day.calories,
            week: weekIndex + 1,
            day: dayIndex + 1,
          });
        });
      }
    );

    return allDays;
  }, [allNutritionsData?.weekWiseData]);

  return (
    <Styles.Container>
      <div className="main-div">
        <MainHeader
          headline={"Auswertung"}
          subHeadline={"Dein Ernährungsplan in der App"}
          handleNextPage={() => handleBtnClick("desktop")}
          noBackButton={true}
        />
        <Styles.ContentSection>
          {!showDesktopView && (
            <div className="text-container">
              <Styles.Title>Dein persönlicher Tagesbedarf</Styles.Title>
              <Styles.Description>
                {allNutritionsData?.advantagesData?.["02_text"]}
              </Styles.Description>

              <LineChart
                heading="Grundumsatz"
                status={undefined}
                description="in 12 Wochen"
                fontSize={13}
                precision={0}
                padding={70}
                width={447}
                height={280} // Increased to make room for the week selectors
                data={LineChartData}
                horizontalGuideLines={3}
                yAxisBetweenRange
                topPadding={20}
                bottomPadding={30}
                axisLabelSpacing={15}
              />
              <Styles.SliderWrapper>
                <Styles.ChartTitle>
                  Deine persönliche Nährstoffverteilung
                </Styles.ChartTitle>
                <Styles.Description>
                  Deine Makronährstoffe haben wir anhand deiner Ernährungsform
                  bestimmt.
                </Styles.Description>
                <Styles.Description>
                  Bei deiner Ernährungsform{" "}
                  {allNutritionsData?.nutritionTypeData?.de_name} setzen sich
                  deine Kalorien aus folgender Verteilung zusammen:
                </Styles.Description>
                <KalorienSlider
                  slidesData={
                    allNutritionsData?.pieChartData?.pieChartData ?? []
                  }
                />
              </Styles.SliderWrapper>
            </div>
          )}
          {showDesktopView && (
            <Styles.DesktopView>
              <Styles.DesktopContentWrapper>
                {/* Left side text content */}
                <Styles.DesktopTextContent>
                  <Styles.Title>
                    Deine persönliche Nährstoffverteilung
                  </Styles.Title>
                  <Styles.Description>
                    Deine Makronährstoffe haben wir anhand deiner Ernährungsform
                    bestimmt.
                  </Styles.Description>
                  <Styles.Description>
                    Bei deiner Ernährungsform{" "}
                    {allNutritionsData?.nutritionTypeData?.de_name} setzen sich
                    deine Kalorien aus folgender Verteilung zusammen:
                  </Styles.Description>
                </Styles.DesktopTextContent>

                {/* Charts row */}
                <div className="row">
                  {allNutritionsData?.pieChartData?.pieChartData?.map(
                    (item, index) => (
                      <Styles.PieChartWrapper key={index}>
                        <BoxTitle margin={"0 0 -20px"}>
                          {index == 0 ? "Trainingstag" : "Trainsfrei"}
                        </BoxTitle>
                        <ContentContainer>
                          <NutritionPieChart data={item} />
                        </ContentContainer>
                        <Details marginTop={"-25px"}>
                          <div className="details-center">
                            <div
                              className="bullet"
                              style={{ backgroundColor: "#C74243" }}
                            ></div>
                            <h3>
                              <span>
                                {parseFloat(item.proteinData).toFixed(0)}%
                              </span>
                              <span>Eiweiß</span>
                            </h3>
                          </div>
                          <div className="details-center">
                            <div
                              className="bullet"
                              style={{ backgroundColor: "#2ECF96" }}
                            ></div>
                            <h3>
                              <span>
                                {parseFloat(item.carbohydratesData).toFixed(0)}%
                              </span>
                              <span>Kohlenhydrate</span>
                            </h3>
                          </div>
                          <div className="details-center">
                            <div
                              className="bullet"
                              style={{ backgroundColor: "#FFC303" }}
                            ></div>
                            <h3>
                              <span>
                                {parseFloat(item.fatData).toFixed(0)}%
                              </span>
                              <span>Fett</span>
                            </h3>
                          </div>
                        </Details>
                      </Styles.PieChartWrapper>
                    )
                  )}
                </div>
              </Styles.DesktopContentWrapper>
            </Styles.DesktopView>
          )}
        </Styles.ContentSection>
      </div>
      <button
        onClick={() => handleBtnClick("mobile")}
        className="btn-dark w-full mt-8 btn-show"
      >
        Weiter
      </button>
    </Styles.Container>
  );
}

export default Kalorien;
